import { render, staticRenderFns } from "./VuesticScrollbar.vue?vue&type=template&id=388dc7cc"
import script from "./VuesticScrollbar.vue?vue&type=script&lang=js"
export * from "./VuesticScrollbar.vue?vue&type=script&lang=js"
import style0 from "./VuesticScrollbar.vue?vue&type=style&index=0&id=388dc7cc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388dc7cc')) {
      api.createRecord('388dc7cc', component.options)
    } else {
      api.reload('388dc7cc', component.options)
    }
    module.hot.accept("./VuesticScrollbar.vue?vue&type=template&id=388dc7cc", function () {
      api.rerender('388dc7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue"
export default component.exports